import { useStaticQuery, graphql } from "gatsby"

export const useHomeCalloutQuery = () => {
  const { wpPage } = useStaticQuery(
    graphql`
      query HomeCalloutQuery {
        wpPage(title: { eq: "Home" }) {
          callout {
            calloutBackgroundImageDesktop {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            calloutBackgroundImageMobile {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            calloutBackgroundImageAltText
            calloutPercent
            calloutTitle
            calloutActionLabel
            calloutLink {
              url
              title
            }
            calloutActionIcon {
              localFile {
                childSvg {
                  content {
                    data
                  }
                }
              }
            }
          }
        }
      }
    `
  )
  return wpPage.callout
}
